import { useCallback } from "react";
import { useRouter } from "next/router";
import { useForm, FormProvider } from "react-hook-form";
import { MainTemplate } from "@/components/templates";
import { PageTitle } from "@/components/molecules";
import { useRequestChangeEmailAddressMutation } from "@/generated/graphql";
import { RequestChangeEmailAddressForm } from "@/components/organisms";
import useRollbarUtil from "../hooks/useRollbarUtil";

type FormValues = {
  email: string;
};

type Props = {
  sub: string;
};

export const RequestChangeEmailAddressPage = ({ sub }: Props) => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();

  const methods = useForm<FormValues>({
    reValidateMode: "onBlur",
    defaultValues: {
      email: "",
    },
  });

  const [requestChangeEmailAddressMutation] =
    useRequestChangeEmailAddressMutation({
      onCompleted: (data) => {
        if (data.requestChangeEmailAddress.result) {
          router.push("/request-change-email-address-completed");
        }
      },
      onError: getNotifyErrorHandlerForGraphQL(
        "Failed to send change email address mail",
        "メールの送付に失敗しました"
      ),
    });

  const handleSubmit = useCallback(
    async ({ email }: FormValues) => {
      await requestChangeEmailAddressMutation({
        variables: {
          input: {
            sub,
            email,
          },
        },
      });
    },
    [requestChangeEmailAddressMutation]
  );

  return (
    <MainTemplate title={`メールアドレスの変更`}>
      <PageTitle
        mainTitle={`メールアドレスの変更`}
        subTitle={
          <>
            メールアドレスを変更する為には新しいメールアドレスでの認証が必要です
            <br />
            新しいメールアドレスを入力して、受信したメールから認証してください
          </>
        }
      />
      <FormProvider {...methods}>
        <RequestChangeEmailAddressForm onSubmit={handleSubmit} />
      </FormProvider>
    </MainTemplate>
  );
};
